module.exports = __webpack_public_path__ + "img/ic-tick-circle-yellow.4a5d6437.svg";